import fetchManager from '@utils/fetchManager';
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");
// const API_URL = 'http://localhost:8080'

export default {
  getListSection: async (querys) => {
    const url = urlQueryData(`${API_URL}/SectionManagement/api/amx/cpe/sections`, querys)
    const response = await fetchManager(url)
    return response
  },
  updateVisibilitySection: async (id, data) => {
    const response = await fetchManager(`${API_URL}/SectionManagement/api/amx/cpe/sections/visibility/${id}`, {
        method: 'PATCH',
        data,
      })
      return response
  },

  deleteSection: async (id, querys, data) => {
    const url = urlQueryData(`${API_URL}/SectionManagement/api/amx/cpe/sections/${id}`, querys)
    const response = await fetchManager(url, {
        method: 'DELETE',
        data,
      })
    return response
  },

  reactiveSection: async (id, data) => {
    const url = urlQueryData(`${API_URL}/SectionManagement/api/amx/cpe/sections/reactive/${id}`)
    const response = await fetchManager(url, {
        method: 'PUT',
        data,
      })
    return response
  },

  reOrderSections: async (data) => {
    const response = await fetchManager(`${API_URL}/SectionManagement/api/amx/cpe/sections/order`,
    {
      method: 'PATCH',
      data,
    })
    return response
  },

  addSection: async (data) => {
    const response = await fetchManager(`${API_URL}/SectionManagement/api/amx/cpe/sections`,
    {
      method: 'POST',
      data,
      headers: {
        'sections': 'x'
      }
    })
    return response
  },

  getDetailSection: async (id) => {
    const response = await fetchManager(`${API_URL}/SectionManagement/api/amx/cpe/sections/${id}`,{
      headers: {
        'sections': 'x'
      }
    })
    return response
  },

  editSection: async (data) => {
    const response = await fetchManager(`${API_URL}/SectionManagement/api/amx/cpe/sections`, {
      method: 'PUT',
      data,
      headers: {
        'sections': 'x'
      }
    })
    return response;
  },

  updateStatusSection: async (id, data, querys) => {
    const url = urlQueryData(`${API_URL}/SectionManagement/api/amx/cpe/sections/${id}`, querys)

    const response = await fetchManager(url,
    {
      method: 'PATCH',
      data,
      headers: {
        'sections': 'x'
      }
    })
    return response
  },

  refreshCache: async (name) => {
    const errorModal = { show: 'no' }

    const response = await fetchManager(`${API_URL}/SectionManagement/api/amx/cpe/sections/refresh/${name}`, {}, errorModal)
    return response
  },
  

  getSectionTree: async (querys) => {
    const url = urlQueryData(`${API_URL}/SectionManagement/api/amx/cpe/sections/tree`, querys)
    const response = await fetchManager(url)
    return response
  },

  getAllSectionTree: async (querys) => {
    const url = urlQueryData(`${API_URL}/SectionManagement/api/amx/cpe/sections/tree`, querys)
    const response = await fetchManager(url)
    return response
  },
};
